import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const ProtectedLogin = ({ auth, component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props => !auth ? (
                <Component {...props} />
            ) :
                (
                    <Redirect to={{pathname: '/screening-room'}} />
                )}

        />
    )
}

export default ProtectedLogin;